var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "创建盘库单",
        "before-close": _vm.close,
        width: "90%",
        "custom-class": "counting-create-editor",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "pb16 pl16 pr16" },
        [
          _c(
            "el-form",
            {
              ref: "queryFormRef",
              attrs: { model: _vm.queryParams, inline: "" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "条码", prop: "barcode" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.queryParams.barcode,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "barcode", $$v)
                      },
                      expression: "queryParams.barcode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "品牌", prop: "brand" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.queryParams.brand,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "brand", $$v)
                      },
                      expression: "queryParams.brand",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "名称", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.queryParams.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "name", $$v)
                      },
                      expression: "queryParams.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "子条码", prop: "childBarcode" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.queryParams.childBarcode,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryParams, "childBarcode", $$v)
                      },
                      expression: "queryParams.childBarcode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "状态", prop: "status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.queryParams.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "status", $$v)
                        },
                        expression: "queryParams.status",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (v, k) {
                      return _c("el-option", {
                        key: "option_" + k,
                        attrs: { value: k, label: v },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.onQuery } },
                    [_vm._v("查询")]
                  ),
                  _c("el-button", { on: { click: _vm.onReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                height: "800",
                border: "",
                "row-key": "id",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "selection",
                  align: "center",
                  width: "55",
                  "reserve-selection": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "商品ID",
                  width: "90",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "brand", label: "商品品牌", width: "130" },
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "商品名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "spec", label: "商品规格", width: "200" },
              }),
              _c("el-table-column", {
                attrs: { prop: "barcode", label: "商品条码", width: "150" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "convertQty",
                  label: "换算数量",
                  width: "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.convertQty === null ||
                        scope.row.convertQty === undefined
                          ? _c("span", { staticClass: "text-placeholder" }, [
                              _vm._v("/"),
                            ])
                          : _c("span", [_vm._v(_vm._s(scope.row.convertQty))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "状态",
                  width: "66",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.status ? "primary" : "info",
                            },
                          },
                          [_vm._v(_vm._s(_vm.statusOptions[scope.row.status]))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  align: "center",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.parseTime(scope.row.createTime)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "updateTime",
                  label: "更新时间",
                  align: "center",
                  width: "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.parseTime(scope.row.updateTime)) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-row",
            {
              staticClass: "mt16 mb16",
              attrs: { type: "flex", justify: "space-between" },
            },
            [
              _c("div", [
                _vm._v(" 已选"),
                _c("span", { staticClass: "text-primary ml4 mr4" }, [
                  _vm._v(_vm._s(_vm.multipleSelections.length)),
                ]),
                _vm._v("条 "),
              ]),
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [15, 30, 60, 90],
                  "page-size": _vm.queryParams.limit,
                  "current-page": _vm.queryParams.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.onSizeChange,
                  "current-change": _vm.onPageChange,
                },
              }),
            ],
            1
          ),
          _c("el-input", {
            staticClass: "mb16",
            attrs: { type: "textarea", placeholder: "请输入备注" },
            model: {
              value: _vm.remark,
              callback: function ($$v) {
                _vm.remark = $$v
              },
              expression: "remark",
            },
          }),
          _c(
            "el-row",
            { staticClass: "mb20", attrs: { type: "flex", justify: "end" } },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: !_vm.multipleSelections.length,
                  },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("提交")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }